<template>
  <aside class="sidebar"><div class="logo"><p>Кабинет клиента</p></div>
    <nav class="main-clients" aria-label="Разделы кабинета"><ul class="menu"><li v-for="section in sections" :key="section.path" class="menu-item"><router-link :to="section.path" active-class="active"><i class="menu-icon" :class="section.icon" aria-hidden="true"></i> {{ section.title }}</router-link></li></ul></nav>
  </aside>
</template>
<script>
import { SECTIONS } from '@/config/setting'
export default { computed: { sections() { return SECTIONS.filter(section => section.path !== '/seo' || this.$store.state.hasSeo) } } }
</script>
